module.exports = __webpack_public_path__ + "static/media/barrio-chino.537deae3.md";